import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  expandedSeparator: {
    backgroundColor: Theme.palette.gray[250],
  },

  tooltipLabel: {
    color: Theme.palette.gray[750],
    flexGrow: '1',
    [Theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
    '& svg': {
      marginBottom: '-5px',
      marginLeft: '4px',
      cursor: 'pointer',
      color: Theme.palette.primary.light,
      width: 16,
    },
  },

  baggageTooltip: {
    maxWidth: '250px',
  },
  baggageTooltipTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    marginBottom: '20px',
  },
  baggageTooltipBags: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    marginBottom: '10px',
    '& span': {
      lineHeight: '150%',
    },
    '& span:first-child': {
      flexGrow: '1',
    },
    '& span:last-child': {
      textAlign: 'right',
    },
  },
  baggageTooltipAdditionalInfo: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[0],
    color: Theme.palette.gray[750],
    marginTop: '20px',
  },
  fareTooltipContainer: {
    maxWidth: 'unset',
    '& > div': {
      [Theme.breakpoints.down('lg')]: {
        paddingTop: '40px',
        '& > button': {
          top: '20px',
        },
      },
    },
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '15px !important',
    },
  },
  fareTooltip: {
    width: '440px',
    [Theme.breakpoints.down('sm')]: {
      width: 'calc(100vw - 80px)',
      maxWidth: '440px',
    },
  },
  fareTooltipTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.primary.main,
  },
  fareTooltipSubtitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[1],
  },
  fareTooltipRow: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    marginBottom: '20px',
    marginTop: '20px',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[0],
    },
    '&:first-child': {
      marginBottom: '10px',
      marginTop: '0px',
    },
    '&:last-child': {
      marginBottom: '0px',
    },
    '& span': {
      lineHeight: '150%',
      width: '50%',
      '&:first-child': {
        [Theme.breakpoints.down('xs')]: {
          width: '40%',
        },
      },
      '&:last-child': {
        marginLeft: '50px',
        [Theme.breakpoints.down('sm')]: {
          marginLeft: '40px',
        },
        [Theme.breakpoints.down('xs')]: {
          width: '60%',
        },
      },
    },
  },
}));

export default useStyles;
